import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flow"];
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import ClassicAnchoredDelayActionCard from 'automation-ui-action-features/actions/classic-anchored-delay/ClassicAnchoredDelayActionCard';
import { getClassicEventAnchor, getClassicRecurAnnually } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import wireFlow from 'automation-ui-canvas/decorators/WiredFlowDecorator';
import { jsx as _jsx } from "react/jsx-runtime";
function ClassicAnchoredDelayActionCardWrapper(_ref) {
  let {
      flow
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ClassicAnchoredDelayActionCard, Object.assign({}, props, {
    eventAnchor: getClassicEventAnchor(flow),
    recurAnnually: !!getClassicRecurAnnually(flow)
  }));
}
export default compose(withRouter, wireFlow)(ClassicAnchoredDelayActionCardWrapper);